import React from 'react'
import { Link, useLocation } from "react-router-dom"

import SearchForm from "../components/SearchForm"

import {
  years,
} from "../services/timelineService"
import CornerLogo from "../images/cornerLogo.svg"
import Music from './Music'

const sampleData = require("../fixtures/content.json")
function NavBar(props) {
  const location = useLocation()

  return (
    <div className='top-bar'>
        <div className='top-bar__logo'>
          <Link to={{ pathname: "/", state: { prevPath: location.pathname } }}>
            <img src={CornerLogo} className='corner-logo' alt='corner-logo' />
          </Link>
        </div>
        <div className="top-bar__music">
          { typeof props.currentSegment === "number" && sampleData.years[years[props.currentSegment]].music &&
            <Music musicPlaying={props.musicPlaying} currentSegment={props.currentSegment} />}
        </div>
        <div className='top-bar__nav'>
          <Link
            to={{ pathname: location.pathname.includes("timeline") ? "/search" : "/timeline", state: { prevPath: location.pathname } }}
            className='top-bar__nav__link'
          >
              {location.pathname.includes("timeline") ? "List of honorees" : "Explore the timeline"}
          </Link>
          <a className='top-bar__nav__link'
            href='https://vision.appreciatehub.com/ui/anniversary/list/8FYVKnwcia-SOhIGxtAkOC5S4ewzi3xiWnKYP8z7fHTScGG_OeqKM_rq_ON3L72Mx2f_-ywHFSCu0dyhrOkyqu3DsASHor9_YGVJdCyQJauUzTwTMfnDnRzt3GhzbaMpJEqYL2MP'
            target='_blank'
            rel='noopener noreferrer'
          >
              Visit the yearbook
          </a>
        </div>
        <div className="top-bar__search">
          <SearchForm />
        </div>
      </div>
  )
}

export default NavBar
